import { CommonData } from '../common_schema'

export const scaleInoutData: CommonData[] = [
  {
    name: 'Store Region Count',
    mean: '[manual]',
    std: '[manual]',
    location: `[manual] PD --> Statistics - balance --> Store Region Count<br />
    [manual] Progress left second `
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
